/**
 * Ordergroove Logout Handler
 * Removes the og_auth cookie when user logs out
 */

export default function ordergrooveLogout() {
    // Find all logout links
    const logoutLinks = document.querySelectorAll('a[href*="/logout"]');

    if (logoutLinks.length === 0) {
        return;
    }

    /**
     * Remove the Ordergroove authentication cookie
     */
    function removeOrdergrooveCookie() {
        // Delete og_auth cookie by setting it to expire in the past
        document.cookie = 'og_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure; SameSite=Lax';
        console.log('Ordergroove authentication cookie removed on logout');
    }

    // Attach click handler to all logout links
    logoutLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            // Remove the cookie when logout is clicked
            removeOrdergrooveCookie();
            // Allow the logout to proceed normally
        });
    });
}
